import "../css/timer.scss";
// import TimeLeft from "./timeLeft";
import CTA from "../components/CTA";
import Lottie from "react-lottie";
import * as animationData from "../assets/timerStickersLottie.json";
import { v4 as uuidv4 } from "uuid";

const TimerComponent = (props) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const formAction = window.location.origin.includes("localhost")
    ? "http://localhost/yotpo/request-a-demo"
    : window.location.origin + "/request-a-demo";

  return (
    <div className="timer-component">
      <div className="stickers">
        <Lottie options={defaultOptions} />
      </div>
      <div className="timer-wrap">
        {/* <span className="title font-regular">{props.timer_title}</span> */}
        <div className="timer">
          {/* <TimeLeft datetime={props.time_until_event} /> */}
          Get BFCM-ready
        </div>
        <span className="line-separator"></span>
        {/* <p className="font-regular">{props.text}</p> */}
        <p className="font-regular">It's never too early to prepare! Talk to a strategist today about BFCM 2023.</p>
        <form
          className="radform"
          noValidate
          form-id={uuidv4()}
          data-location="BFCM Top header"
          action={formAction}
          method="post"
        >
          <input type="email" name="rad_email" placeholder="Enter your email" />
          <CTA
            href={props.cta.url}
            title={props.cta.title}
            icon="arrow-right"
            isPreFillRad={props.isPreFillRad}
            segmentLocation="Top header"
          />
        </form>
      </div>
    </div>
  );
};

export default TimerComponent;
